import { render, staticRenderFns } from "./comList.vue?vue&type=template&id=0cf65c52&scoped=true&"
import script from "./comList.vue?vue&type=script&lang=js&"
export * from "./comList.vue?vue&type=script&lang=js&"
import style0 from "./comList.vue?vue&type=style&index=0&id=0cf65c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf65c52",
  null
  
)

export default component.exports